<div class="modal-header">
  <h5 class="modal-title" id="modal-basic-title">Permissions</h5>
  <button class="close" aria-label="Close" (click)="activeModal.dismiss()">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="d-flex flex-column px-5 m-auto">
  <div class="row p-2">
    <span class="col-md-4"></span>
    @for (permission of permissions; track permission) {
      <div class="col-md-2 text-center">
        {{ permission?.permissionRoleString }}
      </div>
    }
  </div>

  <div class="row p-2">
    <div class="col-md-4">
      <span>
        Submit/View Monthly Bill Comparison
      </span>
    </div>
    @for (permission of permissions; track permission) {
      <div class="col-md-2 text-center">
        @if (permission.coreFeatures) {
          <fa-icon [icon]="faCheck"></fa-icon>
        }
      </div>
    }
  </div>

  <div class="row p-2">
    <div class="col-md-4">
      <span >
        Manage Users/Utility Providers
      </span>
    </div>
    @for (permission of permissions; track permission) {
      <div class="col-md-2 text-center">
        @if (permission.manageUsers) {
          <fa-icon [icon]="faCheck"></fa-icon>
        }
      </div>
    }
  </div>

  <div class="row p-2">
    <div class="col-md-4">
      <span> Can Change User Permissions </span>
    </div>
    @for (permission of permissions; track permission) {
      <div class="col-md-2 text-center">
        @if (permission.canChangePermissions) {
          <fa-icon [icon]="faCheck"></fa-icon>
        }
      </div>
    }
  </div>

  @if (isAdmin) {
    <div class="row p-2">
      <div class="col-md-4">
        <span ngbTooltip="View automated jobs."> View Quartz Jobs </span>
      </div>
      @for (permission of permissions; track permission) {
        <div class="col-md-2 text-center">
          @if (permission.viewQuartzJobs) {
            <fa-icon [icon]="faCheck"></fa-icon>
          }
        </div>
      }
    </div>
  }

  @if (isAdmin) {
    <div class="row p-2">
      <div class="col-md-4">
        <span ngbTooltip="Edit Monthly Bill Comparison (After Submission)"> Admin Features </span>
      </div>
      @for (permission of permissions; track permission) {
        <div class="col-md-2 text-center">
          @if (permission.adminFeatures) {
            <fa-icon [icon]="faCheck"></fa-icon>
          }
        </div>
      }
    </div>
  }

  <div class="mx-auto p-3">
    <button type="button" class="btn btn-cancel btn-lg" (click)="activeModal.dismiss()">Cancel</button>
  </div>
</div>
